export const GlobalHooks = () => {
  // useMarketDataGraphqlAction();

  return null;
};
